'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { AddressIconView } from '../../components/Common/AddressIcon/AddressIconView';
import { ImageWithFallback, WalletIcon } from '@layerswap/ui-kit/components';
/**
 * Renders a wallet's icon. After the contract migration to `Wallet.icon: string`,
 * use this component everywhere instead of `<wallet.icon />`. Falls back to a
 * generative AddressIcon when the wallet didn't ship an icon URL.
 */
const WalletIconPresentation = ({ wallet, className, size = 24, addressIcon, }) => {
    if (wallet.icon) {
        return (_jsx(ImageWithFallback, { src: wallet.icon, alt: wallet.displayName ?? wallet.id, width: size, height: size, className: clsx('max-w-none object-contain', className) }));
    }
    if (wallet.address) {
        return (addressIcon ?? (_jsx(AddressIconView, { address: wallet.address, size: size, className: className })));
    }
    return _jsx(WalletIcon, { className: className });
};
export default WalletIconPresentation;
